import { HeadingH4Atom, IconAtom } from "../../atoms";
import styles from "./styles.module.scss";

interface Props {
  icon: string;
  label: string;
  type: "default" | "alert";
}

export function IconLabelMolecule(props: Readonly<Props>) {
  let className = styles.container;

  if (props.type !== "default") {
    const styleType = styles[`container--${props.type}`];
    className += ` ${styleType}`;
  }

  return (
    <div className={className}>
      <IconAtom icon={props.icon} size={"large"} alt={props.icon} />
      <HeadingH4Atom>{props.label}</HeadingH4Atom>
    </div>
  );
}
